import {ErrorBoundary} from '@github-ui/react-core/error-boundary'

export function HideOnError({children}: {children: React.ReactNode}) {
  return (
    <ErrorBoundary boundaryName="global-navigation-hide-on-error" fallback={null}>
      {children}
    </ErrorBoundary>
  )
}
